export default "__VITE_ASSET__nUJcErQN__"